import { HttpMethod, HttpOption } from '@/utils/http-client'

export class BankCardAPIConstant {
    /**
     * 页面根据条件分页查询用户银行卡列表
     */
    BankCardList = (data): HttpOption => ({
        url: '/front/bankcard/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 为用户添加银行卡
     */
    AddBankCard = (data): HttpOption => ({
        url: '/front/bankcard/add',
        method: HttpMethod.POST,
        data
    })

    /**
     * 更新用户银行卡
     */
    UpdateBankCard = (data): HttpOption => ({
        url: '/front/bankcard/update',
        method: HttpMethod.POST,
        data
    })

    /**
     * 批量启用银行卡
     */
    BatchEnable = (data): HttpOption => ({
        url: '/front/bankcard/batchEnable',
        method: HttpMethod.POST,
        data
    })

    /**
     * 批量冻结银行卡
     */
    BatchProhibit = (data): HttpOption => ({
        url: '/front/bankcard/batchProhibit',
        method: HttpMethod.POST,
        data
    })
}
